import React, { useContext, useEffect, useState } from 'react'
import {
  CButton,
  CCol,
  CFormInput,
  CFormLabel,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from '@coreui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import { raiseToast } from '../../../utils/helper'
import useAxios from 'axios-hooks'
import { CHANGE_PASSWORD } from '../../../utils/urls'
import { AppContext } from '../../../context/app'
import { GlobalContext } from '../../../../views/context/GlobalState'
import { logoutAction } from '../../../../Redux/Actions/authAction'

const ChangePassword = (props) => {
  const { showModal, handleClose } = props
  //   const [password, setPassword] = useState('')
  const [newPasswordHide, setNewPasswordHide] = useState(true)
  const [cnfPasswordHide, setCnfPasswordHide] = useState(true)
  const [errorData, setErrorData] = useState({})
  const { setLoader } = useContext(AppContext)
  const { userObj } = useContext(GlobalContext)

  console.log(userObj)

  //   const [{ data: resetPasswordData, loading: resetPasswordLoading }, resetPasswordCall] = useAxios(
  //     {
  //       url: RESET_USER_PASSWORD,
  //       method: 'put',
  //     },
  //     { manual: true },
  //   )

  //   const validateInfo = () => {
  //     let isFormValid = true
  //     let temp = {}

  //     if (!password && password.trim().length === 0) {
  //       isFormValid = false
  //       temp.password = 'Password cannot be Empty!'
  //     }

  //     if (password !== cnfPassword) {
  //       isFormValid = false
  //       temp.cnfPassword = 'Confirm Password should be same as that of password!'
  //     }

  //     setErrorData({ ...temp })
  //     return isFormValid
  //   }
  //   const handleResetPassword = () => {
  //     if (validateInfo()) {
  //       resetPasswordCall({
  //         data: {
  //           user_id: user._id,
  //           password: password,
  //         },
  //       })
  //     }
  //   }

  //   useEffect(() => {
  //     setLoader(resetPasswordLoading)
  //   }, [resetPasswordLoading])

  //   useEffect(() => {
  //     if (resetPasswordData && resetPasswordData.success) {
  //       handleClose()
  //       raiseToast('success', 'Password reset successfully')
  //     }
  //   }, [resetPasswordData])

  const [oldPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (newPassword !== confirmPassword) {
      isFormValid = false
      temp.confirmPassword = `Passwords Don't Match!`
    }
    if (oldPassword.trim().length === 0) {
      isFormValid = false
      temp.oldPassword = `Old Password Cannot be Empty!`
    }
    if (newPassword.trim().length === 0) {
      isFormValid = false
      temp.newPassword = `Password Cannot be Empty!`
    }
    if (confirmPassword.trim().length === 0) {
      isFormValid = false
      temp.confirmPassword = `Password Cannot be Empty!`
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const handleChange = (event, func) => {
    const { value, name } = event.target

    if (errorData[`${name}`]) {
      delete errorData[`${name}`]
      setErrorData({ ...errorData })
    }
    func(value)
  }

  const [{ data: changePasswordRes, loading: changePasswordLoading }, changePasswordCall] =
    useAxios(
      {
        url: CHANGE_PASSWORD,
        method: 'post',
      },
      { manual: true },
    )

  useEffect(() => {
    setLoader(changePasswordLoading)
  }, [changePasswordLoading])

  const handleSubmit = async () => {
    if (validateInfo()) {
      changePasswordCall({
        data: {
          user_id: userObj._id,
          new_password: newPassword,
          old_password: oldPassword,
        },
      })
    }
  }

  const handleLogout = async () => {
    const res = await logoutAction()

    if (res?.success) {
      // context.logoutUser()
      localStorage.clear()
      window.location.reload()
    }
  }

  useEffect(() => {
    if (changePasswordRes && changePasswordRes.success) {
      emptyState()
      handleLogout()
      raiseToast('success', 'Password changed successfully')
      handleClose()
    }
  }, [changePasswordRes])

  const emptyState = () => {
    setErrorData({})
    setOldPassword('')
    setNewPassword('')
    setConfirmPassword('')
  }
  return (
    <>
      <CModal size="lg" visible={showModal} alignment="center">
        <CModalHeader className="px-5 py-4">
          <CModalTitle>{'Change Password'} </CModalTitle>
        </CModalHeader>
        <CModalBody className="px-5 py-4">
          <CRow className="mt-3">
            <CCol style={{ position: 'relative' }}>
              <CFormLabel>Old Password*</CFormLabel>
              <CFormInput
                type={'password'}
                value={oldPassword}
                name="oldPassword"
                onChange={(e) => handleChange(e, setOldPassword)}
              />
              <div className="message-text error-message">
                <p>{errorData.oldPassword}</p>
              </div>
            </CCol>
          </CRow>
          <CRow className="mt-3">
            <CCol style={{ position: 'relative' }}>
              <CFormLabel>New Password*</CFormLabel>
              <CFormInput
                type={newPasswordHide ? 'password' : 'text'}
                value={newPassword}
                name="password"
                onChange={(e) => handleChange(e, setNewPassword)}
              />
              <div
                style={{
                  position: 'absolute',
                  right: '5%',
                  top: errorData.newPassword ? '45%' : '55%',
                }}
              >
                {!newPasswordHide ? (
                  <FontAwesomeIcon
                    icon={faEye}
                    size="lg"
                    onClick={() => setNewPasswordHide(true)}
                  />
                ) : (
                  <FontAwesomeIcon
                    icon={faEyeSlash}
                    size="lg"
                    onClick={() => setNewPasswordHide(false)}
                  />
                )}
              </div>
              <div className="message-text error-message">
                <p>{errorData.newPassword}</p>
              </div>
            </CCol>
          </CRow>
          <CRow className="mt-3">
            <CCol style={{ position: 'relative' }}>
              <CFormLabel>Confirm Password*</CFormLabel>
              <CFormInput
                type={cnfPasswordHide ? 'password' : 'text'}
                value={confirmPassword}
                name="password"
                onChange={(e) => handleChange(e, setConfirmPassword)}
              />
              <div
                style={{
                  position: 'absolute',
                  right: '5%',
                  top: errorData.confirmPassword ? '45%' : '55%',
                }}
              >
                {!cnfPasswordHide ? (
                  <FontAwesomeIcon
                    icon={faEye}
                    size="lg"
                    onClick={() => setCnfPasswordHide(true)}
                  />
                ) : (
                  <FontAwesomeIcon
                    icon={faEyeSlash}
                    size="lg"
                    onClick={() => setCnfPasswordHide(false)}
                  />
                )}
              </div>
              <div className="message-text error-message">
                <p>{errorData.confirmPassword}</p>
              </div>
            </CCol>
          </CRow>
        </CModalBody>
        <CModalFooter>
          <CButton className="text-white" color="info" onClick={handleSubmit}>
            Change Password
          </CButton>
          <CButton className="text-white" color="info" onClick={handleClose}>
            Cancel
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default ChangePassword
